import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="none"
					image={require('./image.jpg')}
					title={"Email Signature Best Practices"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle lauren"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>Lauren</strong> on 25 June 2020  //  Posted in <strong>Graphic Design</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
									Email Signature Best Practices
								</div>
								

<h3>Email signatures should always be designed with the purpose of informing your audience, and creating easy points of contact.</h3>
<br></br>
<p>We’ve all been there - you’ve decided on a brand for your new company, you’ve made a business plan for moving forward, and you’re excited about getting all of your marketing material ready for roll out… and your first piece of marketing? Your email signature.</p>

<p>But as exciting as gimmicky, flashy email signatures may seem, there are certain technical and functional aspects to consider when it comes to designing one. <b>An email signature is designed as an information piece vs a promotional piece </b>. It has to deliver the key contact information clearly with minimal obstacles and distractions.</p>
<br></br>
<h5>A successful email signature will:</h5> 

<ul>
<li>Contain <i>simple</i> graphics, if any at all</li>
<li>Be displayed clearly across mobile, tablet and desktop devices</li>
<li>Provide easy contact paths through clickable links</li>
<li>Display correctly across all email platforms (Outlook, Gmail etc) </li>
<li>Use a highly accessible font to ensure maximum functionality of links and information (such as Arial or Times New Roman)</li>

</ul>


<br></br>
<hr></hr>
<h1>Design Considerations for your Email Signature</h1>
<p>There are a few key design principles to remember when creating an email signature. Design philosophy encourages a 'less is more' approach. It also pushes the idea of 'form follows function', meaning the desired purpose/use/device/audience all have to be considered for its final form.</p>
<p>Big and glitzy is not always better - something small but impactful, with clear messaging and clickable links will be much more effective in the long run.</p>
<p>Our designers have been creating professional email signatures for decades, and have added their best design tips below.</p>
<img src={require('./image-4.png')} width="600" alt="Moshi Moshi Email Signature"/>
<br></br>
<hr></hr>
<h2>Align your image and text</h2>
<p>The key difference between an email signature that looks polished and professional, and a signature that looks sloppy and thrown together is the correct alignment.</p>
<p>We recommend the good ol' left alignment principle. Given that the path of a user's eye reads from left to right, top to bottom, using a left aligned design means you can highlight your most important information first, and end with the dessert - your clickable links.</p>
<p>Left alignment creates a professional, clean and tidy signature, and when teamed with an appropriately sized image, looks extremely polished.</p>

<img src={require('./image-3.png')} width="400" alt="Left Aligned Email Signature Example"/> 
<br></br>
<h6><a href="https://www.yesware.com/blog/email-signature/">image source</a></h6>
<br></br>
<hr></hr>
<h2>Select fonts that are common and accessible</h2>
<p>When designing your signature, it's important to keep in mind that not all email providers/platforms are built the same. Some will have completely different fonts installed to others, which will break your signature if you haven't put this into consideration.</p>
<p>Where possible, use a default system font (such as Arial, Times New Roman, Verdana), to avoid any font breakages from other email providers. Custom fonts or branded fonts should be embedded into an image if they are absolutely needed.</p>
<p>Email signatures can become too busy very easily. Less is more when it comes to content - avoid over-cluttering your signature with unnecessary links, facts and statements, and try to put new information on a new line where you can.</p>


<br></br>
<hr></hr>
<h2>Keep images to a minumum</h2>
<p>Any unique styling to email signatures is most often done via embedded images. We try to keep things as simple as possible, as embedding images can create a whirlwind of issues if not done correctly.</p>
<h4>Some key considerations to remember:</h4>
<p><b>Images do not always render properly in email signatures.</b> Some email platforms will simply show them as an empty box until the user clicks to download them, making for an inefficient use of space, as well as giving a highly unprofessional impression.</p>
<p><b>The bigger the file size, the longer to load.</b> The bigger the size and the more complex information used on the embedded image will result in increased file size. This puts extra stress on bandwidth between servers and network traffic.</p>
<p><b>Embedded contact information defeats the primary objective of the email signature in the first place.</b> One image = one clickable link for the end user. This means you're losing out on valuable real estate that could be used to get direct clicks to your website, Google Maps listing, mobile number and more.</p>
<p>Not only that, but including key information such as phone numbers, titles, names etc into an embedded image can result in serious accessibility issues for potential users relying on screen reading technology to navigate digital information.</p>
<p>And most importantly, <b> images don't always look the same across desktop and mobile.</b> We generally cap the width of our email signatures at around 600px wide, resulting in well rendered mobile results. Any smaller than that would make reading the information close to impossible.</p>
<p>You can also include social links as images that are individually clickable. In our example below, we have included our <a href="https://www.facebook.com/StartWithMoshi"> Facebook page</a> as an image. The choice is yours, but make sure your images are the correct dimensions in their original file, as editing within your email is a nightmare. </p>


<img src={require('./image-1.jpg')} width="400" alt="Moshi Moshi Email Signature Example"/> 
<br></br>
<hr></hr>
<h2>Key Points</h2>
<ul>
<li>Keep images small, and left align where possible.</li>
<li>Use ready installed fonts where possible, or opt for a Google font (bear in mind these might default to a system font on some systems). Any script/custom fonts should be converted into an image.</li>
<li>Place new contact information on a new line.</li>
<li>Make sure your image files are created and saved out at the correct pixel dimensions to start with.</li>

</ul>




<p>If you would like to update or create your email signature from scratch, don't be afraid to get in touch with the<a href="http://moshi.com.au/whatwedo/graphic-design"> experts</a>.</p>







							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/EmailSigs/index.js